import { Github, Twitter } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-20 pb-10 bg-[var(--vb-bg-deeper)] border-t border-[var(--vb-border)]"
    >
      <div className="container-x">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-2.5 h-2.5 rounded-full bg-[var(--vb-primary)]" />
              <span className="font-display font-extrabold text-xl">
                Verbatim
              </span>
            </div>
            <p className="text-[var(--vb-muted)] text-sm max-w-md leading-relaxed">
              Read anything. <i className="italic">Learn everything.</i>
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="mono-label mb-4">Product</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#how" className="hover:text-[var(--vb-primary)]">
                  How it works
                </a>
              </li>
              <li>
                <a href="#demo" className="hover:text-[var(--vb-primary)]">
                  Reader
                </a>
              </li>
              <li>
                <a href="#features" className="hover:text-[var(--vb-primary)]">
                  Features
                </a>
              </li>
              {/* <li>
                <a href="#pricing" className="hover:text-[var(--vb-primary)]">
                  Pricing
                </a>
              </li> */}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="mono-label mb-4">Features</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-[var(--vb-primary)]">
                  Reader
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[var(--vb-primary)]">
                  Dictionary
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[var(--vb-primary)]">
                  Bring your own texts
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[var(--vb-primary)]">
                  Any language you want
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="mono-label mb-4">Contact</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-[var(--vb-primary)]">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[var(--vb-primary)]">
                  Email
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[var(--vb-primary)]">
                  Linkedin
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[var(--vb-primary)]">
                  Portfolio
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="relative pb-8">
          <div className="font-display font-extrabold tracking-tighter leading-none text-[24vw] sm:text-[18vw] md:text-[14rem] lg:text-[16rem] text-[var(--vb-primary)]/90 select-none">
            verbatim
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 pt-6 border-t border-[var(--vb-border)]">
          <div className="text-xs font-mono text-[var(--vb-muted)]">
            © 2026 Verbatim · Read anything. <i className="italic">Learn everything.</i>
          </div>
        </div>
      </div>
    </footer>
  );
};
